<div class="nav vertical">
    @for (item of navigation; track $index) {
        @switch (item.type) {
            @case ('group') {
                <fuse-nav-vertical-group [item]="item"></fuse-nav-vertical-group>
            }
            @case ('collapsable') {
                <fuse-nav-vertical-collapsable [item]="item"></fuse-nav-vertical-collapsable>
            }
            @case ('item') {
                <fuse-nav-vertical-item [item]="item"></fuse-nav-vertical-item>
            }
        }
    }
</div>
